<template>
  <div class="container d-flex flex-center fd-column p-x-1:mo m-y-5">
    <client-only>
      <app-login-as-form class="m-b-2"/>
    </client-only>
  </div>
</template>

<script>
import AppLoginAsForm from '@/components/AppLoginAsForm';

export default {
  name: 'login-as',
  metaInfo: {
    title: 'Login As',
  },
  components: {
    AppLoginAsForm,
  },
  prefetch ({ store }) {
    return Promise.all([
      store.dispatch('auth/fetchAccessToken'),
    ]);
  },
  computed: {

  },
};
</script>
